import {URL_BASE_API } from '../configs/urlConfigs' 

import service from './api';

export const rolesList = (request) => {
  let ROLES_ENDPOINT = URL_BASE_API+'user/roles/';
  if(request.data!==undefined){      
    // let pageId = request.data.page;
    // let column = request.data.column;     
    // if(column||pageId){
    //   ROLES_ENDPOINT = URL_BASE_API+'user/roles/?page='+pageId+'&column='+column;
    // }
  }else{
    ROLES_ENDPOINT = URL_BASE_API+'user/roles/';
  }   

  return service.get(ROLES_ENDPOINT);
  
};

export const rolesAdd = (request) => {
  let ROLES_ENDPOINT = URL_BASE_API+'user/roles/';
  return service.post(ROLES_ENDPOINT,request.data)
};

export const rolesEdit = (request) => {
  let rolesId = request.data;
  const ROLES_ENDPOINT = URL_BASE_API+'user/roles/'+rolesId;

  return service.get(ROLES_ENDPOINT);  
  
};

export const rolesUpdate = (request) => {
  let rolesId = request.data.id;
  let ROLES_ENDPOINT = URL_BASE_API+'user/roles/'+rolesId;
  let editDate = {
    name: request.data.name,
    permissions: request.data.permissions
  }

  return service.put(ROLES_ENDPOINT,editDate);  // request.data
  
};

export const rolesDelete = (request) => {
  let ROLES_ENDPOINT = URL_BASE_API+'user/roles/'+request.data;
  return service.delete(ROLES_ENDPOINT);   
};  

export const rolesPermissionUpdate = (request) => {
  let rolesId = request.data.id; 
  // let ROLES_ENDPOINT = URL_BASE_API+'user/roles/'+rolesId;
  let ROLES_ENDPOINT = URL_BASE_API+'user/role-permissions/'+rolesId;
  console.log('request: '+JSON.stringify(request)); 
  let editDate = {
    name: request.data.name,
    permissions: request.data.permissions
  }

  return service.put(ROLES_ENDPOINT,editDate);  // request.data
  
};


